import React, { useCallback, useState, useContext } from 'react'
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux'
import styles from './CreateModule.module.css'
import { Box } from '@mui/material';
import { useNavigate } from "react-router-dom";
import validator from 'validator';
import * as actions from '../../../../store/actions/index'
import SubModal from '../../../UI/Crm/SubModal/SubModal'
import CrmDivider from '../../../UI/Crm/CrmLayout/CrmDivider'
import CrmButton from '../../../UI/Crm/CrmButton/CrmButton'
import CrmTextField from '../../../UI/Crm/Fields/CrmTextField'
import CrmCheckBoxField from '../../../UI/Crm/Fields/CrmCheckBoxField';
import AlertContext from '../../../../context/AlertModelContext/AlertModalContext'
import IconPicker from '../../../UI/Crm/IconPicker/IconPicker';
import { createCrmModule } from '../../../../axios/requests/moduleReq'

const CreateModule = ({
    show = false,
    onHide = () => { }
}) => {
    const [t] = useTranslation('crm')
    const dispatch = useDispatch()
    const alertCtx = useContext(AlertContext)
    const navigate = useNavigate();
    const [newModuleObj, setNewModuleObj] = useState({})
    const [errors, setErrors] = useState({});

    const onSaveClickedHandler = useCallback(async () => {
        try {
            // Show loading spinner in alert modal
            alertCtx.showAlert('', <div style={{textAlign: 'center', padding: '20px'}}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>, 'md')

            const module = await createCrmModule(newModuleObj)
            if (module?.name) {
                alertCtx.hideAlert() // Hide loading spinner
                onHide?.(module)
            }

        } catch (e) {
            alertCtx.showAlert(t('Error'), t(e.message), 'md')
        }
    }, [newModuleObj])

    const onHideClickedHandler = useCallback(() => {
        console.log('onHideClickedHandler')
        onHide?.()
    }, [])

    const validations = useCallback((name, value) => {
        if (typeof value !== 'string') return
        if (name === 'name') {
            if (validator.isEmpty(value)) {
                return `${t('Module name')}: ${t(`Required`)}`;
            }

            if (!validator.isAlpha(value, 'en-US')) {
                return `${t('Module name')}: ${t(`Only x letters are allowed`, { x: t('English') })}`;
            }

            if (!validator.isLength(value, { min: 5 })) {
                return `${t('Module name')}: ${t(`Must be more than x characters`, { x: 4 })}`;
            }

            if (!validator.isLength(value, { max: 16 })) {
                return `${t('Module name')}: ${t(`Must not exceed x characters`, { x: 16 })}`;
            }
        }
        if (name === 'label') {
            if (validator.isEmpty(value)) {
                return `${t('Show label')}: ${t(`Required`)}`;
            }

            if (!validator.isLength(value, { min: 3 })) {
                return `${t('Show label')}: ${t(`Must be more than x characters`, { x: 2 })}`;
            }

            if (!validator.isLength(value, { max: 16 })) {
                return `${t('Show label')}: ${t(`Must not exceed x characters`, { x: 16 })}`;
            }
        }
        return;
    }, [])

    const handleChange = useCallback((e) => {
        const { name, value, type, checked } = e.target;
        setNewModuleObj((prevModuleObj) => {
            const newModuleObj = { ...prevModuleObj }
            newModuleObj[name] = type === 'checkbox' ? checked : value
            return newModuleObj
        })

        const error = validations(name, value);
        setErrors((prev) => ({ ...prev, [`${name}`]: error }));

    }, [])

    const onSelectModuleIconHandler = useCallback((IconElement) => {
        handleChange({
            target: {
                name: 'icon',
                value: IconElement
            }
        })
    }, [])

    return show &&
        <SubModal
            modalTitle={t('Create new module')}
            onHide={onHide}
        >
            <Box
                component="form"
                onSubmit={(e) => e.preventDefault()}
                noValidate
                sx={{
                    p: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        p: 2
                    }}
                >
                    <CrmTextField label={t('Module name')} name="name" placeholder={'Contacts'} value={newModuleObj.name} onChange={handleChange} autoComplete='off' errorMsg={errors.name} />
                    <CrmTextField label={t('Show label')} name="label" placeholder={t('Contacts')} value={newModuleObj.label} onChange={handleChange} autoComplete='off' errorMsg={errors.label} />
                    <CrmTextField label={t('Single record name')}
                        name="crmName"
                        value={newModuleObj.crmName}
                        onChange={handleChange}
                        tooltip={t('This name will be used when navigating from a module to a sub-module and for identifying a single record. For example, in the Contacts module, the single record name would be the contacts name.')}
                        autoComplete='off'
                        errorMsg={errors.crmName}
                        placeholder={t('Contact name')}
                    />

                    <IconPicker
                        onSelect={onSelectModuleIconHandler}
                        selected={newModuleObj.icon}
                        maxHeight={450}
                        title={t('Select module icon')}
                    />
                    {/* <CrmCheckBoxField label={t('Is deletable')} name="isDeletable" value={newModuleObj.isDeletable} onChange={handleChange} /> */}

                </Box>

                <CrmDivider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="flex-end" gap={2}>
                    <CrmButton color="crmContainedGray94" onClick={onSaveClickedHandler}>
                        {t('Save')}
                    </CrmButton>
                    <CrmButton color="crmOutlinedGray94" onClick={onHideClickedHandler}>
                        {t('Cancel')}
                    </CrmButton>
                </Box>
            </Box>
        </SubModal>

}

export default CreateModule